<template>
  <!-- Kontener zakresowego filtra: flexowy układ w wierszu -->
  <div class="filter">
    <!-- Etykieta filtra: wyświetla przekazaną nazwę -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora "od": wyświetlany z odpowiednią klasą -->
    <span class="symbol">{{ symbolFrom }}</span>
    <!-- Pole input dla wartości minimalnej:
         - atrybut name odpowiada props.fieldFromName
         - v-model.lazy wiąże wartość po zdarzeniu 'change'
         - blokada scrollowania i dotyku, aby zapobiec przypadkowym zmianom
    -->
    <input
      :name="fieldFromName"
      v-model.lazy="valueFrom"
      type="number"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol operatora "do": analogicznie do 'from' -->
    <span class="symbol">{{ symbolTo }}</span>
    <!-- Pole input dla wartości maksymalnej -->
    <input
      :name="fieldToName"
      v-model.lazy="valueTo"
      type="number"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import { useCurrentFiltersStore } from "../../stores/currentFilters"; // Import store Pinia dla aktualnych filtrów

export default {
  name: "RangeFilter",
  props: ["name", "symbolFrom", "fieldFromName", "symbolTo", "fieldToName"],

  setup(props) {
    const filtersStore = useCurrentFiltersStore();

    // v-model podpinamy bezpośrednio do store przez computed setter.
    // Zapis jest synchroniczny — dzięki temu po kliknięciu „Zastosuj" w kroku 2
    // wartości są w store ZANIM watcher na current.step odpali checkData()
    // i wyśle pierwsze zapytanie. Wcześniej, z `ref` + `watch`, watcher zapisu
    // do store flushował się po watcherze step → pierwsze żądanie szło bez
    // filtrów masy/długości/itp. i wpadał pojazd nie spełniający kryteriów.
    const valueFrom = computed({
      get: () => filtersStore.filters[props.fieldFromName] ?? "",
      set: (val) => filtersStore.addItem(props.fieldFromName, val),
    });
    const valueTo = computed({
      get: () => filtersStore.filters[props.fieldToName] ?? "",
      set: (val) => filtersStore.addItem(props.fieldToName, val),
    });

    return { valueFrom, valueTo, filtersStore };
  },
};
</script>

<style scoped>
/* Wiersz filtra zakresowego: etykieta — [od] pole — [do] pole.
   Wiersz wpina się w siatkę kolumn `.vehicle-half--grid` (CurrentVehicleData.vue)
   przez `subgrid`, więc etykieta, oba operatory i oba pola stoją w tych samych
   kolumnach co w pozostałych wierszach formularza — także w wierszu filtra
   pojedynczego. Odstępy kolumn dziedziczymy z rodzica. */
.filter {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  min-width: 0;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--border-subtle);
}

.filter:last-child {
  border-bottom: 0;
}

/* Bez własnej szerokości — wyznacza ją wspólna kolumna siatki, więc „Od"
   i „Do" zajmują tyle samo miejsca niezależnie od tłumaczenia. */
.symbol {
  text-align: center;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  text-transform: lowercase;
}

input {
  width: auto;
  min-width: 0;
  text-align: center;
}
</style>
